@for (panel of panels(); track panel.key) {
  <p-accordion-panel [attr.data-test]="panel.dataTest + '-panel'"
                     [value]="panel.key"
  >
    <div #subPanel
         class="accordion-panel-scroll-target"
         [attr.data-index]="nav.getSectionIndex(mainIndex()!, panel.key)"
    ></div>
    <p-accordion-header [attr.data-test]="panel.dataTest + '-header'">
      <p class="section-title"> {{ panel.label }} </p>
    </p-accordion-header>
    <p-accordion-content [attr.data-test]="panel.dataTest + '-content'">
      @if (activePanels().includes(panel.key)) {
        <albert-standard-sub-coverage-form
          [attr.data-test]="panel.dataTest + '-sub-form'"
          [form]="subCoverageForm(panel)"
          [isCreateMode]="isCreateMode()"
          [memberExternalId]="memberExternalId()"
          [policyStatus]="policyStatus()"
        />
        <ng-container *ngTemplateOutlet="panelExtra() ?? null; context: { $implicit: panel }"/>
      }
    </p-accordion-content>
  </p-accordion-panel>
}
